import classNames from 'classnames';
import type * as React from 'react';
import styles from './style.m.less';

type Props = {
    children: React.ReactNode;
    className?: string;
    small?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const InputIcon = ({ children, className, small, ...otherProps }: Props) => (
    <div
        className={classNames(styles.inputIcon, { [styles.default]: !small, [styles.small]: small }, className)}
        {...otherProps}
    >
        {children}
    </div>
);
